import React from "react";
import { oncogenicityIcon } from "./oncoKBHelpers";

function oncoKBIcon(
  oncogenicity,
  therapeuticLevel,
  diagnosticLevel,
  resistanceLevel,
  prognosticLevel
) {
  const therapeuticColors = {
    1: "#33a02c", // level 1 - light green
    2: "#1f78b4", // level 2 - blue
    "3A": "#984ea3", // level 3a - purple
    "3B": "#b28cbd", // level 3b - light purple
    4: "#424242", // level 4 - black
  };

  let therapeuticColor;
  let diagnosticColor;
  let resistanceColor;
  let prognosticColor;

  if (therapeuticLevel) {
    therapeuticColor = therapeuticColors[therapeuticLevel];
  }

  const diagnosticColors = ["#33a02c", "#1f78b4", "#984ea3"]; // light green, blue, purple
  if (diagnosticLevel) {
    diagnosticColor = diagnosticColors[diagnosticLevel - 1];
  }

  const resistanceColors = {
    R1: "#ee3424", // level r1 - dark red
    R2: "#f79a92",
  }; // level r2 - light red

  if (resistanceLevel) {
    resistanceColor = resistanceColors[resistanceLevel];
  }

  const prognosticColors = ["#33a02c", "#1f78b4", "#984ea3"]; // light green, blue, purple
  if (prognosticLevel) {
    prognosticColor = prognosticColors[prognosticLevel - 1];
  }

  return (
    <svg viewBox="-10 -10 140 120" style={{ height: "1.6rem", width: "auto" }}>
      {/* Main Target Shape */}
      {oncogenicityIcon(oncogenicity, "2rem")}

      {/* Therapeutic Level (Upper Left) */}
      {therapeuticLevel ? (
        <circle cx="30" cy="30" r="21" fill={therapeuticColor} />
      ) : null}

      {/* Diagnostic Level (Upper Right) */}
      {diagnosticLevel ? (
        <rect x="90" y="10" width="35" height="35" fill={diagnosticColor} />
      ) : null}

      {/* Resistance level (Bottom Left) */}
      {resistanceLevel ? (
        <circle cx="30" cy="80" r="21" fill={resistanceColor} />
      ) : null}

      {/* Prognostic Level (Bottom Right - Triangle) */}
      {prognosticLevel ? (
        <polygon points="105,60 85,100 135,100" fill={prognosticColor} />
      ) : null}
    </svg>
  );
}

export default oncoKBIcon;
